import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import MenuDrawer from '../components/Drawer/MenuDrawer';

const LayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%',
  minHeight: '100vh',
  width: '100%',
}));

export const LayoutDashboard = (props) => {
  const { children } = props;

  return (
    <>
      <MenuDrawer />
      <LayoutRoot>{children}</LayoutRoot>
    </>
  );
};

LayoutDashboard.propTypes = {
  children: PropTypes.node,
};
